import { MapType } from 'features/maps/types'
import { MapDatasetEnriched } from '../types'

export function canUseGlobal(source: MapDatasetEnriched) {
  const { type } = source
  return type !== MapType.tileset
}
